// Where to start exploring a tree (GET /tree/landmarks on the tools service):
// the people with both many ancestors and many descendants, the ones a family
// knows. The caller's Gramps token decides the tree, as for the stories.

import { reportUnauthorized } from './grampsApi';
import { getToolsApiBase } from './ocr';

export interface Landmark {
    handle: string;
    gramps_id: string;
    ancestors: number;
    descendants: number;
}

export async function fetchLandmarks(token?: string): Promise<Landmark[]> {
    const response = await fetch(`${getToolsApiBase()}/tree/landmarks`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    // A stale token is refreshed, and the list asked again with the new one.
    if (response.status === 401) {
        reportUnauthorized(token);
        throw new Error('Landmarks request refused: the token is stale');
    }
    // No access is not an error for a visitor: there is just nothing to propose.
    if (response.status === 403) return [];
    if (!response.ok) throw new Error(`Landmarks request failed: HTTP ${response.status}`);
    return ((await response.json()) as { people: Landmark[] }).people;
}
